import axios from "axios";

// base url to make requests to the movie database
const instance = axios.create({
  baseURL: "https://api.themoviedb.org/3",
});

//below will result https://api.themoviedb.org/3/foo-bar,
// instance.get("/foo-bar");

// there can be only one export default for each file, however export can be used multiple times
export default instance;
